import {
  Typography
} from "./chunk-W3K5MNAD.js";
import {
  FontAwesomeIcon
} from "./chunk-APS5QAFW.js";
import {
  cn,
  twVariants
} from "./chunk-LJ5F4WFH.js";

// src/Alert/Alert.tsx
import * as React from "react";
var alertStyles = twVariants({
  slots: {
    root: "flex gap-2 rounded-lg bg-danger-alert p-2",
    rootIcon: "mt-[3px] size-4 shrink-0"
  },
  variants: {
    variant: {
      info: {
        root: "bg-information-alert text-information-alert-text",
        rootIcon: "text-information-alert-icon"
      },
      success: {
        root: "bg-success-alert text-success-alert-text",
        rootIcon: "text-success-alert-icon"
      },
      warning: {
        root: "bg-warning-alert text-warning-alert-text",
        rootIcon: "text-warning-alert-icon"
      },
      error: {
        root: "bg-danger-alert text-danger-alert-text",
        rootIcon: " text-danger-alert-icon"
      }
    },
    closable: {
      true: {
        root: "[&_.alert-description]:pr-4"
      }
    }
  },
  defaultVariants: {
    variant: "info"
  }
});
var variantToIcon = {
  info: "circle-info:regular",
  success: "circle-check:regular",
  warning: "triangle-exclamation:regular",
  error: "circle-exclamation:regular"
};
var Alert = React.forwardRef(
  ({
    icon,
    className,
    variant = "info",
    open = true,
    onClose,
    children,
    ...props
  }, ref) => {
    const { root, rootIcon } = alertStyles({
      variant,
      closable: !!onClose
    });
    const iconClassName = rootIcon();
    const hasTitle = React.Children.toArray(children).filter((child) => !!child).length > 1;
    return open ? /* @__PURE__ */ React.createElement("div", { ref, role: "alert", className: cn(root(), className), ...props }, icon ? /* @__PURE__ */ React.createElement("span", { className: iconClassName }, icon) : /* @__PURE__ */ React.createElement(
      FontAwesomeIcon,
      {
        name: variantToIcon[variant ?? "info"],
        className: iconClassName
      }
    ), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cn(
          "grow space-y-1 text-left",
          hasTitle ? "-mt-px" : "mt-px"
        )
      },
      children
    ), onClose ? /* @__PURE__ */ React.createElement(
      "button",
      {
        onClick: onClose,
        className: "flex size-4 items-center justify-center rounded-sm bg-transparent transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-radiant-blue focus-visible:ring-offset-2 active:scale-90"
      },
      /* @__PURE__ */ React.createElement(FontAwesomeIcon, { name: "xmark:regular", className: iconClassName }),
      /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, "Close")
    ) : null) : null;
  }
);
Alert.displayName = "Alert";
var AlertTitle = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React.createElement(
  Typography,
  {
    variant: "body-1",
    ref,
    className: cn("font-semibold", className),
    ...props
  }
));
AlertTitle.displayName = "AlertTitle";
var AlertDescription = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React.createElement(Typography, { variant: "body-2", ref, className: cn(className), ...props }));
AlertDescription.displayName = "AlertDescription";

export {
  alertStyles,
  Alert,
  AlertTitle,
  AlertDescription
};
//# sourceMappingURL=chunk-6JR7Y6MT.js.map